<template>
  <v-app>
    <v-main>
      <router-view
        :apiLink="apiLink"
        :activeRate="activeRate"
        :activeRateValue="activeRateValue"
        @changeActiveRate="changeActiveRate"
      />
    </v-main>

    <v-footer app>
      <Footer />
    </v-footer>
  </v-app>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  name: "App",
  components: {
    Footer,
  },
  data: () => ({
    apiLink: "https://zamowienia.e-gecos.pl",
    // apiLink: "http://192.168.75.120:80/zamawiarka-master",
    activeRate: "PLN",
    rateEUR: 0,
    rateGBP: 0,
  }),
  computed: {
    activeRateValue() {
      if (this.activeRate == "EUR") return this.rateEUR;
      else if (this.activeRate == "GBP") return this.rateGBP;
      else return 1;
    },
  },
  methods: {
    changeActiveRate(newRate) {
      console.log("changeActiveRate", newRate);

      this.activeRate = newRate;
      localStorage.currentRate = newRate;
    },
    async getCurrencyRate(currencyName) {
      const res = await this.axios({
        method: "get",
        url: `https://api.nbp.pl/api/exchangerates/rates/A/${currencyName}?format=json`,
      });
      return Number(res.data.rates[0].mid.toFixed(2));
    },
  },
  async created() {
    if (localStorage.themeDarkMode) {
      this.$vuetify.theme.dark = JSON.stringify(localStorage.themeDarkMode);
    }

    if (localStorage.currentRate) {
      this.activeRate = localStorage.currentRate;
    }

    this.rateEUR = await this.getCurrencyRate("EUR");
    this.rateGBP = await this.getCurrencyRate("GBP");
  },
};
</script>

<style></style>
